export const vnode = (message, h, events) => {
  return h('div', {
    attrs: {
      role: 'alertdialog',
      'aria-label': 'message',
      'aria-describedby': 'message-dialog-desc',
    },
  }, [
    h('p', {
      style: {
        paddingRight: '32px',
      },
    }, [
      h('span', {
        attrs: {
          id: 'message-dialog-desc',
        },
      }, message),
      h('zm-button', {
        props: {
          type: 'link',
        },
        class: {
          'mgl-sm': true,
        },
        on: {
          click: (...args) => events(...args),
        },
      }, 'Undo Change'),
    ]),
  ]);
};
